homeIngredients = {
    init: function () {
        $(".section-home-ingredients").each(function () {
            var section = $(this);

            function setActive(key) {
                if (!key) {
                    key = 1;
                }

                section.find("[data-ingredient-key]").removeClass("active");
                section.find('[data-ingredient-key="' + key + '"]').addClass("active");
            }

            section.find(".home-ingredients__title").off("click.homeIngredients").on("click.homeIngredients", function () {
                setActive($(this).data("ingredient-key"));
            });

            setActive(section.find(".home-ingredients__title").first().data("ingredient-key"));
        });
    }
};

$(document).ready(function () {
    homeIngredients.init();
});

$(document).on("shopify:section:load", function () {
    homeIngredients.init();
});
